import { Chip, ChipProps } from '../02-atoms/Chip';

export interface ChipsProps {
  /** Chip objects */
  items: ChipProps[];
  /** Additional class */
  className?: string;
}

/** List of chips */
export const Chips = ({ items, className, ...props }: ChipsProps) => {
  return (
    <ul className={['chips', className].join(' ')} {...props}>
      {items.map((item, i) => {
        return (
          <li key={i} className="chips__chip">
            <Chip {...item} />
          </li>
        );
      })}
    </ul>
  );
};
